import CustomDialogBox from "../global/CustomDialogBox.component";
import CustomInput from "../global/CustomInput.component";
import CustomButtonLoader from "../global/CustomButtonLoader.component";
import useWindowSize from "../../hooks/useWindowSize";
import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useSelector } from "react-redux";
import CustomToolTip from "../custom-tooltip/CustomTooltip.component";
import { replaceDynamicString } from "../../utils/helperFn";

const MfaDialogBox = ({
  t,
  isOpen = false,
  mfadataHandler,
  onSaveHandler,
  data,
  textBoxStr,
  textBoxStrHandler,
}) => {
  const windowSize = useWindowSize();
  const envState = useSelector((state) => state.env);
  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (!textBoxStr.value) {
      textBoxStrHandler({
        ...textBoxStr,
        msg: "empty_passcode_please_try_again",
      });
      return;
    }
    onSaveHandler(textBoxStr.value);
  };

  const renderAuthenticators = () => {
    if(envState?.AUTHENTICATORS) {
      const struct = [" "];
      envState.AUTHENTICATORS.forEach((authenticator, index, arr) => {

        if(index === (arr.length - 1)) {
          struct.push(" " + t("or") + " ");
        }

        struct.push(
          authenticator.enabled ? <a
            className="text-action-1 cm-pointer"
            href={authenticator.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t(authenticator.value)}
          </a> : <CustomToolTip
            title={replaceDynamicString(t("authenticator_method_unavailable_in_your_region"), [t(authenticator.value)])}
            disableTooltip={authenticator.enabled}
          >
            <span className="cm-action-disabled cm-default">{t(authenticator.value)}</span>
          </CustomToolTip>
        ) 

        if(index < (arr.length - 2)) {
          struct.push(", ");
        }
      });

      struct.push(" ")

      return struct;
    }

    return null;
  }

  return (
    <CustomDialogBox
      t={t}
      dialogHeading={t("setup_authenticator_app")}
      cancelFn={() => {
        textBoxStrHandler({ value: "", msg: null });
        mfadataHandler({ modalOpenToggle: false });
      }}
      dialogStatus={isOpen}
      disabled={false}
      buttonArrayData={[]}
    >
      <p className="cm-sm-txt text-blue-gray-700 mb-0">
        {t("download_install_any_authenticator_apps_like_auth")}
        {renderAuthenticators()}
        {t("to_generate_login_codes")}
      </p>
      <div className="border-top border-bottom border-blue-gray-200 my-4 py-4">
        <div className={`d-flex ${windowSize.isMobile ? "flex-column" : ""}`}>
          <div
            className={`border border-blue-gray-300 cm-btn-radius ${
              windowSize.isMobile ? "mx-auto" : "me-4"
            } `}
            style={{ height: "180px", width: "180px" }}
          >
            <img
              src={data.qrcode}
              alt={"qr_image"}
              className={`img-fluid cm-btn-radius`}
            />
          </div>
          <div
            style={
              windowSize.isMobile ? { maxWidth: "auto" } : { maxWidth: "345px" }
            }
          >
            <p className="cm-sm-txt fw-medium text-blue-800 mt-3 mb-1">
              {t("scan_qr_code")}
            </p>
            <p className="cm-sm-txt fw-medium text-blue-gray-700 fw-medium mb-0">
              {t("open_authenticator_app_and_scan_the_qr_code")}
            </p>
            <p
              className={`cm-sm-txt fw-medium text-blue-800 mb-0 ${`${
                windowSize.isMobile ? "mt-3" : "mt-4"
              }`}`}
            >
              {t("or_manually_enter_the_following_below_code")}
            </p>
            <p className="cm-sm-txt fw-medium text-blue-gray-700 mb-1">
              {data?.manualCode}
            </p>
          </div>
        </div>
      </div>
      <p className="cm-sm-txt fw-medium text-blue-gray-700 mb-2">
        {t("enter_the_digit_verification_code_generated")}
      </p>
      <form
        onSubmit={handleFormSubmit}
        className={`d-flex cm-text-number ${
          windowSize.isMobile ? "flex-column" : ""
        }`}
      >
        <CustomInput
          type="number"
          value={textBoxStr?.value}
          style={{ width: "360px" }}
          inputClass="w-100"
          onChange={(e) => {
            if (e.target?.value?.length > 6) return;
            textBoxStrHandler({ value: e.target.value, msg: null });
          }}
          min="0"
          max="1000000"
          msg={t(textBoxStr?.msg)}
          hasError={!!textBoxStr?.msg}
          placeholder={t("enter_code_here")}
        />
        <div
          className={`${
            windowSize.isMobile
              ? "border-blue-gray-200 border-top mt-4 pt-2"
              : ""
          }`}
        />
        <CustomButtonLoader
          showLoadingState={false}
          disabled={false}
          icon={regular("angle-right")}
          buttonLabel={t(`${t("submit")}`)}
          colorTheme={"blue"}
          buttonStyle={`py-10 px-3 cm-mar-left-icon ${
            windowSize.isMobile ? "flex-column mt-3" : "ms-4"
          }`}
          handleOnClick={() => {}}
        />
      </form>
    </CustomDialogBox>
  );
};

export default MfaDialogBox;
